import React from "react";
export const TabordionGroup = ({ children, ...rest }) => {
    return (
        <div style={{ paddingTop: "1rem" }} {...rest}>
            {children}
        </div>
    );
};
